export const userKeyData = {
  classDefaultKey: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  controlDefaultKey: ["{arrowup}", "{arrowdown}", "{enter}"],
  etcDefaultKey: ["{tab}"],
  etcDefaultConfig: ["{tab}"],
  controlKeyToSymbol: {
    arrowup: "↑",
    arrowdown: "↓",
    arrowleft: "←",
    arrowright: "→",
    enter: "⏎",
    space: "␣",
    tab: "↹",
    shift: "⇧",
    capslock: "⇪",
  },
  forbiddenKeys: ["capslock", "escape", "backspace"],
  disabledKeys: ["{esc}", "{bksp}", "{capslock}", ""],

  validControlKey: [
    "{arrowup}",
    "{arrowdown}",
    "{arrowleft}",
    "{arrowright}",
    "{space}",
    "{enter}",
    "{ }",
    " ",
  ],
  validEtcKey: ["{tab}"],
};

export const projectKeyData = {
  classDefaultKey: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  disabledKeys: ["{esc}", "{bksp}", "{capslock}", ""],
  forbiddenKeys: ["tab", "capslock", "enter", "escape", "backspace"],
};

export const keyboardLayout = {
  default: [
    "{esc} F1 F2 F3 F4 F5 F6 F7 F8 F9 F10 F11 F12",
    "{`} 1 2 3 4 5 6 7 8 9 0 {-} {=} {bksp}",
    "{tab} Q W E R T Y U I O P {[} {]} {\\}",
    "{capslock} A S D F G H J K L {;} {'} {enter}",
    "{shift} Z X C V B N M {,} {.} {/} {arrowup} {empty}",
    "{control} {meta} {alt} {space} {alt} {fn} {control} {arrowleft} {arrowdown} {arrowright}",
  ],
};

export const keyboardDisplay = {
  "{esc}": "ESC",
  "{bksp}": "⌫",
  "{tab}": "↹",
  "{enter}": "⏎",
  "{shift}": "⇧",
  "{capslock}": "⇪",
  "{space}": "␣",
  "{control}": "Ctrl",
  "{meta}": "Win",
  "{alt}": "Alt",
  "{fn}": "Fn",
  "{arrowup}": "↑",
  "{arrowdown}": "↓",
  "{arrowleft}": "←",
  "{arrowright}": "→",
  "{empty}": " ",
  "{\\}": "\\",
  "{,}": ",",
  "{.}": ".",
  "{/}": "/",
  "{;}": ";",
  "{'}": "'",
  "{[}": "[",
  "{]}": "]",
  "{`}": "`",
  "{=}": "=",
  "{-}": "-",
};

export const commonKeyData = {
  allKeys: [
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12",
    // Number row
    "{`}",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
    "{-}",
    "{=}",
    // "{bksp}",
    // First letter row
    "{tab}",
    "Q",
    "W",
    "E",
    "R",
    "T",
    "Y",
    "U",
    "I",
    "O",
    "P",
    "{[}",
    "{]}",
    "{\\}",
    // Second letter row
    // "{capslock}",
    "A",
    "S",
    "D",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "{;}",
    "{'}",
    "{enter}",
    // Third letter row
    "{shift}",
    "Z",
    "X",
    "C",
    "V",
    "B",
    "N",
    "M",
    "{,}",
    "{.}",
    "{/}",
    "{arrowup}",
    "{empty}",
    // Bottom row
    "{control}",
    "{meta}",
    "{alt}",
    "{space}",
    "{alt}",
    "{fn}",
    "{control}",
    "{arrowleft}",
    "{arrowdown}",
    "{arrowright}",
  ],
  validClassKey: [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
    "{-}",
    "{=}",
    "Q",
    "W",
    "E",
    "R",
    "T",
    "Y",
    "U",
    "I",
    "O",
    "P",
    "{[}",
    "{]}",
    "A",
    "S",
    "D",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "{;}",
    "{'}",
    "Z",
    "X",
    "C",
    "V",
    "B",
    "N",
    "M",
    "{,}",
    "{.}",
    "{/}",
    "{empty}",
  ],
  specialKey: {
    "-": "{-}",
    "+": "{+}",
    "*": "{*}",
    "/": "{/}",
    "=": "{=}",
    ".": "{.}",
    ",": "{,}",
    ";": "{;}",
    "'": "{'}",
    "[": "{[}",
    "]": "{]}",
    "{": "{{}",
    "}": "{}}",
    "|": "{|}",

    // " ": "{space}",
  },
  defaultClassKey: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  defaultControlKey: ["{arrowup}", "{arrowdown}", "{enter}"],
  defaultEtcKey: ["{tab}"],
};

export const org_keyMap: Record<string, string> = {
  arrowup: "ArrowUp",
  arrowdown: "ArrowDown",
  arrowleft: "ArrowLeft",
  arrowright: "ArrowRight",
  pagedown: "PageDown",
  pageup: "PageUp",
  home: "Home",
  end: "End",
};
